module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showReport) ? _c('div', {
    staticClass: "report"
  }, [_c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_vm._v("Da clic en alguna de las siguientes opciones para visualizar el "), _c('u', [_vm._v("reporte de auditoría")]), _vm._v(" al inmueble "), _c('strong', [_vm._v(_vm._s(_vm.audit.inmueble))])]), _vm._v(" "), _c('p', {
    staticClass: "mdl-typography--text-center"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": _vm.downloadReport
    }
  }, [_vm._v("Descargar Reporte")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    on: {
      "click": _vm.showReportOnScreen
    }
  }, [_vm._v("Visualizar en Página")])]), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }]
  }), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reportLoaded),
      expression: "reportLoaded"
    }],
    attrs: {
      "id": "iframeid",
      "src": _vm.reportSrc,
      "width": "100%",
      "height": "100%"
    },
    on: {
      "load": _vm.showReportOnScreenEnd
    }
  })], 1) : _c('div', {
    staticClass: "incidences"
  }, [_c('header', [_c('div', {
    staticClass: "card-cover mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__media",
    style: ({
      background: 'url(' + _vm.audit.cover + ') center / cover'
    })
  }), _vm._v(" "), _c('div', {
    class: ['mdl-card__title', _vm.audit.promedio ? (_vm.audit.promedio >= _vm.audit.aceptable ? 'bg-green' : (_vm.audit.promedio > _vm.audit.inaceptable ? 'bg-yellow' : 'bg-red')) : 'bg-grey']
  }, [_c('div', {
    staticClass: "mdl-card__title_1"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.inmueble))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.audit.empresa))])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__title_2"
  }, [_c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.incidencias))]), _vm._v(" "), _c('small', [_vm._v("Incidencias")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('strong', [_vm._v(_vm._s(_vm.audit.promedio ? _vm.audit.promedio : 'N / A'))]), _vm._v(" "), _c('small', [_vm._v("Puntos")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__helper"
  }, [_c('small', [_vm._v(_vm._s(_vm.audit.statusNombre.toUpperCase()))])])])]), _vm._v(" "), _vm._l((_vm.audit.mantenimiento), function(responsable) {
    return _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('div', {
      staticClass: "minilogo",
      style: ({
        backgroundImage: 'url(' + responsable.avatar + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-grow-2"
    }, [_c('strong', [_vm._v(_vm._s(responsable.nombre))]), _vm._v(" "), _c('span', [_vm._v("Responsable de Mantenimiento")])]), _vm._v(" "), _c('div')])
  })], 2)]), _vm._v(" "), _c('main', [_vm._l((_vm.incidencias), function(incidencia, i) {
    return _c('div', {
      staticClass: "card-main mdl-card mdl-shadow--2dp"
    }, [_c('div', {
      staticClass: "mdl-card__title"
    }, [_c('h2', {
      staticClass: "mdl-card__title-text"
    }, [_c('strong', [_vm._v(_vm._s(incidencia.area))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(incidencia.rubro))])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__helper"
    }, [_c('small', [_vm._v(_vm._s(incidencia.especificacion.toUpperCase()))]), _vm._v(" "), _c('button', {
      class: ['current-chip', 'mdl-chip',
        'mdl-color--' + incidencia.color
      ],
      attrs: {
        "type": "button"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__media"
    }, _vm._l((incidencia.imagenes.split(',')), function(imagen, k) {
      return _c('div', {
        key: k,
        staticClass: "mdl-card mdl-shadow--2dp",
        style: ({
          background: 'url(' + incidencia.origen + imagen + ') center / cover'
        })
      }, [_c('div', {
        staticClass: "mdl-card__title mdl-card--expand"
      }), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__actions"
      }, [_c('span', {
        staticClass: "mdl-card__filename"
      }, [_vm._v("\n                " + _vm._s('Imagen #' + (k + 1) + ' de la incidencia.') + "\n              ")])]), _vm._v(" "), _c('div', {
        staticClass: "mdl-card__menu",
        staticStyle: {
          "left": "16px"
        }
      }, [_c('button', {
        staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect",
        attrs: {
          "data-i": i,
          "data-k": k
        },
        on: {
          "click": _vm.downloadPicture
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("file_download")])])])])
    })), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_c('div', {
      staticClass: "mdl-card__previus"
    }, [_c('div', {
      staticClass: "minilogo",
      style: ({
        backgroundImage: 'url(' + '' + ')'
      })
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(incidencia.observaciones))])]), _vm._v(" "), _c('div', {
      staticClass: "plan-trabajo"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__additional-text"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.$user.data.avatar || './img/profile-64.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (incidencia.planTrabajo.descripcion),
        expression: "incidencia.planTrabajo.descripcion"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "rows": "3",
        "disabled": _vm.audit.statusId !== 3
      },
      domProps: {
        "value": (incidencia.planTrabajo.descripcion)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          incidencia.planTrabajo.descripcion = $event.target.value
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label"
    }, [_vm._v("Escribe tus observaciones aquí...")])])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__additional-text",
      staticStyle: {
        "margin-left": "4rem"
      }
    }, [_c('div', {
      staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
      staticStyle: {
        "margin-right": "1rem"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (incidencia.planTrabajo.duracion),
        expression: "incidencia.planTrabajo.duracion"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "pattern": "-?[0-9]*(\\.[0-9]+)?",
        "id": 'duracion-' + i,
        "disabled": _vm.audit.statusId !== 3
      },
      domProps: {
        "value": (incidencia.planTrabajo.duracion)
      },
      on: {
        "keydown": _vm.onlyNumbers,
        "input": function($event) {
          if ($event.target.composing) { return; }
          incidencia.planTrabajo.duracion = $event.target.value
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'duracion-' + i
      }
    }, [_vm._v("Duración (días)")]), _vm._v(" "), _c('span', {
      staticClass: "mdl-textfield__error"
    }, [_vm._v("Favor de escribir solo números.")])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
      staticStyle: {
        "margin-left": "1rem"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (incidencia.planTrabajo.costo),
        expression: "incidencia.planTrabajo.costo"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "pattern": "-?[0-9]*(\\.[0-9]+)?",
        "id": 'costo-' + i,
        "disabled": _vm.audit.statusId !== 3
      },
      domProps: {
        "value": (incidencia.planTrabajo.costo)
      },
      on: {
        "keydown": _vm.onlyNumbers,
        "input": function($event) {
          if ($event.target.composing) { return; }
          incidencia.planTrabajo.costo = $event.target.value
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'duracion-' + i
      }
    }, [_vm._v("Costo estimado")]), _vm._v(" "), _c('span', {
      staticClass: "mdl-textfield__error"
    }, [_vm._v("Favor de escribir solo números.")])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.incidencias.length === 0),
      expression: "incidencias.length === 0"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', [_vm._v("Todas las incidencias fueron calificadas en VERDE.")]), _vm._v(" "), _vm._m(1)])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Plan de Trabajo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Es necesario "), _c('strong', [_vm._v("Enviar el Plan de Trabajo")]), _vm._v(" para expresar su consentimiento.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ec6e0b4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Roles/Mantenimiento/Newsfeed/Report.vue
// module id = 234
// module chunks = 0